var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#47A37D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28564 12.0659L7.38564 14.9641C7.45651 15.0629 7.5473 15.1432 7.65122 15.199C7.75514 15.2547 7.86947 15.2845 7.98564 15.2861C8.09995 15.2875 8.21311 15.2616 8.3169 15.2101C8.42069 15.1587 8.51249 15.0831 8.58564 14.9888L15.2856 6.28613",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.246542a8c11f76ce45a645295663349d.svg";
export { ForwardRef as ReactComponent };